export default "__VITE_ASSET__VqgCaNTg__"